import React, { useState, useEffect, useMemo } from "react";
import styles from "../Styles/ui/ListOfFavorites.module.css";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchFavoriteInventory,
  deleteFavorites,
} from "../../../actions/toggleFavorite";
import { AppSidebar } from "./sidebar";
import Header from "../../header";
import { FaSearch, FaTrash } from "react-icons/fa";
import { fetchTemplates } from "../../../actions/saveTemplate";
import { CircularProgress } from "@mui/material";
import { decryptData } from "../../utils/EncriptionStore";
import {Link } from "react-router-dom";
import {FiTrash2} from "react-icons/fi";

const ListOfFavorites = () => {
  const user = (() => {
    const encryptedData = localStorage.getItem("profile");
    return encryptedData ? decryptData(encryptedData) : null;
  })();
  const dispatch = useDispatch();
  
  const [isOpen, setIsOpen] = useState(true);
  const [userQuery, setUserQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const favoritesPerPage = 3;

  const listOfFavorites = useSelector(
    (state) => state.toggleFavorite.favorites
  );

  console.log("Favorites from Redux:", listOfFavorites);

  const templates = useSelector((state) => state.saveTemplate.templates);

  console.log("Templates from Redux:", templates);

  // Fetch templates first, then favorites
  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchTemplates());
      await dispatch(fetchFavoriteInventory());
      setLoading(false);
    };
    fetchData();
  }, [dispatch]);

  useEffect(() => {
    setCurrentPage(1);
  }, [userQuery]);

  // Extract allowed template names
  const allowedTemplateNames = useMemo(() => {
    return templates?.map((t) => (typeof t === "string" ? t : t.name)) || [];
  }, [templates]);

  // Filter by allowed template names + host search
  const filteredFavorites = useMemo(() => {
    const filteredByTemplate = listOfFavorites.filter((item) =>
      allowedTemplateNames.includes(item.inventory_name)
    );

    if (!userQuery.trim()) return filteredByTemplate;

    return filteredByTemplate
      .map((item) => ({
        ...item,
        inventory_hosts: item.inventory_hosts.filter((host) =>
          host.toLowerCase().includes(userQuery.toLowerCase())
        ),
      }))
      .filter((item) => item.inventory_hosts.length > 0);
  }, [listOfFavorites, userQuery, allowedTemplateNames]);

  const totalPages = Math.ceil(filteredFavorites.length / favoritesPerPage);
  const paginatedFavorites = useMemo(() => {
    const start = (currentPage - 1) * favoritesPerPage;
    return filteredFavorites.slice(start, start + favoritesPerPage);
  }, [filteredFavorites, currentPage, favoritesPerPage]);

  const toggleSidebar = () => setIsOpen((prev) => !prev);
  const handleSearch = (e) => setUserQuery(e.target.value);
  const handlePageChange = (direction) => {
    setCurrentPage((prev) =>
      direction === "next"
        ? Math.min(prev + 1, totalPages)
        : Math.max(prev - 1, 1)
    );
  };
  const handleRemoveFavorite = (inventoryName) => {
    dispatch(deleteFavorites({ name: inventoryName, customer_id: user?.customer_id, group_id: user?.group_id, customer_name: user?.customer_name, group_name: user?.groupname }));
  };

  if (loading) return <CircularProgress />;

  return (
    <div className={styles.ListOfFavoritesWrapper}>
      <div className={styles.twoSidebars}>
        <Header />
        <div className={isOpen ? styles.sidebarOpen : styles.sidebarClosed}>
          <AppSidebar isOpen={isOpen} toggleSidebar={toggleSidebar} />
        </div>
      </div>

      <div className={styles.dashboardLayout}>
        <div className={styles.listOfTemplatesHeader}>
          <h2>List of Favorites</h2>
          <div className={styles.listOfTemplatesSearchContainer}>
            <span className={styles.listOfTemplatesSearchIcon}>
              <FaSearch />
            </span>
            <input
              type="text"
              placeholder="Search by Favorite..."
              value={userQuery}
              onChange={handleSearch}
              className={styles.listOfTemplatesSearchInput}
            />
          </div>
        </div>

        <div className={styles.listofTemplatesListContainer}>
          {paginatedFavorites.map((inventory, index) => (
            <div key={index} className={styles.InventoryGroup}>
              <div className={styles.InventoryHeader}>
                <h3>{inventory.inventory_name} </h3>
                <FiTrash2
                  className={styles.DeleteIcon}
                  onClick={() => handleRemoveFavorite(inventory.inventory_name)}
                />
              </div>
              <ul className={styles.HostList}>
                {inventory.inventory_hosts.map((host, i) => (
                  <li key={i}>{host}</li>
                ))}
              </ul>
            </div>
          ))}

          {filteredFavorites.length === 0 && (
            <p className={styles.NoResults}>No favorites match your search.</p>
          )}

          {totalPages > 1 && (
            <div className={styles.Pagination}>
              <button
                onClick={() => handlePageChange("prev")}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() => handlePageChange("next")}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListOfFavorites;
